/**
 * @generated SignedSource<<8c5bbdba343d10e926fed090b0051740>>
 * @relayHash aea879681eafb8d8dc2e8d788d24714d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ac8d9edb75319a93ed7a159d48491fc0f2f009e88d49acb7b2f4c6dd571ae406

import type { ConcreteRequest } from 'relay-runtime';
export type useSegmentationTargetGroupsQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
};
export type useSegmentationTargetGroupsQuery$data = {
  readonly groups: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSegmentationTargetGroupsQuery = {
  response: useSegmentationTargetGroupsQuery$data;
  variables: useSegmentationTargetGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "PaginatedGroupList",
    "kind": "LinkedField",
    "name": "groups",
    "plural": false,
    "selections": [
      {
        "concreteType": "Group",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "endCursor"
          },
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSegmentationTargetGroupsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSegmentationTargetGroupsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aea879681eafb8d8dc2e8d788d24714d",
    "id": "ac8d9edb75319a93ed7a159d48491fc0f2f009e88d49acb7b2f4c6dd571ae406",
    "metadata": {},
    "name": "useSegmentationTargetGroupsQuery",
    "operationKind": "query",
    "text": "query useSegmentationTargetGroupsQuery($after:String,$first:Int=25){groups(after:$after,first:$first){nodes{id,name},pageInfo{endCursor,hasNextPage}}}"
  }
};
})();

(node as any).hash = "b1d866007d469142c79544536019c0ef";

export default node;
